import React, { useEffect, useRef, useState } from "react";

import { CircularProgress } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

import { DEV_MOCK_FB_ACCESS_TOKEN, DEV_MODE } from "Constant/app/process";
import { useDispatch, useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import Swal from "sweetalert2";

import { getSourceIcon } from "helpers/leads/icon";
import { sendFBInfosToServisAsync } from "helpers/leads/leadSources/sendFBInfosToServisAsync";
import {
    getConnectedSourceAsync,
    getSorceApisAsync,
} from "helpers/leads/stepHelpers/sendStep1ToServis";
import { tiktokStore } from "helpers/tiktok-lead/tiktok-lead";

import WizardStepLayout from "components/organisms/WizardStepLayout";

import "../../css/leadStep1.css";
import { getAllLeadDestinationTypesAsync } from "../../redux/slices/leadDestinations/leadDestinations.asyncActions";
import {
    getAllLeadSourcesTypesAsync,
    getGoogleConnectedSources,
} from "../../redux/slices/leadSources/leadSources.asyncActions";
import { resetLastAddedSourceApiData } from "../../redux/slices/leadsWizardSourceDestination/leadsWizardSourceDestination.slice";
import { stepOneData } from "../../redux/slices/step1Datas/step1Datas.slice";
import SwalAlertComp from "../SwalAlert";
import AddEditSourceApi from "./AddEditSourceApi";
import CsvLeadSourceSection from "./SharedComponents/SourceAbstraction/CsvLeadSourceSection";
import {
    buildFacebookSelectedPages,
    normalizeFacebookPages,
    remapFacebookPageAndFormSelections,
} from "./SharedComponents/SourceAbstraction/facebookLeadSource.helpers";
import FacebookLeadSourceSection from "./SharedComponents/SourceAbstraction/FacebookLeadSourceSection";
import GoogleLeadSourceSection from "./SharedComponents/SourceAbstraction/GoogleLeadSourceSection";
import LinkedinLeadSourceSection from "./SharedComponents/SourceAbstraction/LinkedinLeadSourceSection";
import SourceApiLeadSourceSection from "./SharedComponents/SourceAbstraction/SourceApiLeadSourceSection";
import TiktokLeadSourceSection from "./SharedComponents/SourceAbstraction/TiktokLeadSourceSection";

const buildDevMockFacebookPages = () => {
    const now = Date.now();
    const dayMs = 24 * 60 * 60 * 1000;
    return Array.from({ length: 3 }, (_, pageIndex) => {
        const pageId = 900000 + pageIndex;
        const formsCount = 3 + pageIndex * 2;
        return {
            id: pageId,
            page_name: `Dev Mock Page ${pageIndex + 1}`,
            page_forms: Array.from({ length: formsCount }, (_, formIndex) => ({
                id: pageId * 1000 + formIndex,
                parent_id: pageId,
                name: `Mock Lead Form ${pageIndex + 1}-${formIndex + 1}`,
                status: 1,
                created_time: new Date(now - formIndex * dayMs)
                    .toISOString()
                    .slice(0, 19)
                    .replace("T", " "),
            })),
        };
    });
};

const LeadsStep1 = (props) => {
    const dispatch = useDispatch();
    const [sourceSelections, setSourceSelections] = useState(null);
    const [isUseFaceLeadPermission, setIsUseFaceLeadPermission] =
        useState(false);
    const [facebookAccessToken, setFacebookAccessToken] = useState("");
    const [showArchivedForms, setShowArchivedForms] = useState(false);
    const [includeAllForms, setIncludeAllForms] = useState(false);
    const [isFacebookFormsLoading, setIsFacebookFormsLoading] = useState(false);
    const [sourceSelectionCode, setSourceSelectionCode] = useState("");
    const [destinationSelectionCode] = useState("");
    const [appliedFBpermissionOpenSheet, setAppliedFBpermissionOpenSheet] =
        useState(false);
    const [csvPermission, setCsvPermission] = useState(false);
    const [isflOptionsPermission, setIsflOptionsPermission] = useState(false);
    const [sourceSettingsPermission, setSourceSettingsPermission] =
        useState("idle");
    const [receiveNewForms, setReceiveNewForms] = useState(true);
    const [isSourceApiModalOpen, setIsSourceApiModalOpen] = useState(false);
    const [allZohoFields] = useState([]);
    const [sourceApiPermission, setSourceApiPermission] = useState(false);
    const [googlePermission, setGooglePermission] = useState(false);
    const [tiktokPermission, setTiktokPermission] = useState(false);
    const [tiktokStoreData, setTiktokStoreData] = useState({});
    const [tiktokAppStatus, setTiktokAppStatus] = useState(false);
    const [shouldRenderLinkedin, setShouldRenderLinkedin] = useState(false);
    const [selectedSourceApiId, setSelectedSourceApiId] = useState("");
    const [selectedConnectedSource, setSelectedConnectedSource] = useState("");
    const [selectedConnectedSourceApiId, setSelectedConnectedSourceApiId] =
        useState("");
    const [
        selectedConnectedSourceApiPages,
        setSelectedConnectedSourceApiPages,
    ] = useState();
    const [selectedPages, setSelectedPages] = useState([]);
    const [selectedPagesForms, setSelectedPagesForms] = useState([]);
    const [changedSelectedPagesForms, setChangedSelectedPagesForms] = useState(
        [],
    );
    const [connectFaceLeadsListChanged, setConnectFaceLeadsListChanged] =
        useState([]);
    const [selectedPageFormsValue, setSelectedPageFormsValue] = useState([]);
    const [connectionSourceName, setConnectionSourceName] = useState(null);
    const [businessIdState, setBusinessIdState] = useState("");
    const [selectedWebServiceId, setSelectedWebServiceId] = useState();
    const [connectFaceLeadsList, setConnectFaceLeadsList] = useState([]);
    const [sourceApiList, setSourceApiList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [sourceConnectedList, setSourceConnectedList] = useState([]);

    const [loadingForSourceApi, setLoadingForSourceApi] = useState(false);
    const [connectedSourceInput, setConnectedSourceInput] = useState(false);

    const [isSourceSelected, setIsSourceSelected] = useState(false);
    const [tiktokReceiveNewForms, setTiktokReceiveNewForms] = useState(true);
    const [leadFbLoaderStatus, setLeadFbLoaderStatus] = useState(false);
    const [, setNextButtonDisabled] = useState(true);
    const [selectedTiktokForms, setTiktokSelectedForms] = useState([]);
    const [linkedinData, setLinkedinData] = useState(null);
    const [selectedLinkedinSource, setSelectedLinkedinSource] = useState(null);
    const [shouldLoadLinkedinForms, setShouldLoadLinkedinForms] =
        useState(true);

    const language = useSelector((state) => state.languagesState.languages);
    const allLeadSource = useSelector(
        (state) => state.leadAllSourcesState.getAllLeadSourcesTypes.leadSources,
    );

    const bussiness = useSelector(
        (state) => state.allDashboardDatasState.getAllDashboardDatas.bussiness,
    );
    const lastAddedService = useSelector(
        (state) => state.leadslastAddedSourceDestinationState.service,
    );
    const lastAddedSourceApi = useSelector(
        (state) => state.leadslastAddedSourceDestinationState.wizzardSource,
    );
    const googleConnectedSources = useSelector(
        (state) => state.leadAllSourcesState.googleConnectedSourcesList,
    );
    const sourceSelectRef = useRef(null);

    useEffect(() => {
        dispatch(getAllLeadSourcesTypesAsync());
        dispatch(getAllLeadDestinationTypesAsync());
    }, [dispatch]);

    const runDispatcherAfterCreate = () => {
        getSourceApis();
        setNextButtonDisabled(false);
    };

    useEffect(() => {
        let businessId =
            bussiness &&
            bussiness.length > 0 &&
            bussiness.find((element) => element.selected === true);
        if (businessId.id) {
            setBusinessIdState(businessId.id);
        }
    }, [bussiness]);

    const handleSelectedPages = (value) => {
        if (tiktokPermission) {
            setSelectedConnectedSourceApiPages(value);
        }
        setSelectedPages(value);
    };
    const handleSelectedPagesForms = (value) => {
        setSelectedPageFormsValue(value);
        if (
            includeAllForms &&
            (value.length !== changedSelectedPagesForms.length ||
                !changedSelectedPagesForms.every((form) =>
                    value.includes(form.value),
                ))
        ) {
            setIncludeAllForms(false);
        }
    };
    const handleConnectionSourceName = (e) => {
        setConnectionSourceName(e.target.value);
    };

    const sourceOnChange = (value, option) => {
        setAppliedFBpermissionOpenSheet(false);
        setSelectedConnectedSourceApiId("");
        setFbSourceFormStatus(false);
        setFbReadySourceSelectStatus(false);
        setSelectedConnectedSource(null);
        setSelectedConnectedSourceApiPages([]);
        setSelectedConnectedSourceApiId(null);
        setSelectedPagesForms([]);
        setSelectedPageFormsValue([]);
        setConnectFaceLeadsListChanged([]);
        setConnectionSourceName(null);
        setSelectedPages([]);
        setFacebookAccessToken("");
        setShowArchivedForms(false);
        setIncludeAllForms(false);
        setSelectedConnectedSource("");
        setSourceConnectedList([]);
        if (value === null) {
            setSourceSelections(null);
            return;
        }
        dispatch(resetLastAddedSourceApiData());
        setSelectedSourceApiId("");
        setSourceSelections(option.label);
        setSourceSelectionCode(option.value);
        setIsSourceSelected(false);
        setSourceSettingsPermission("idle");
        setSelectedLinkedinSource(null);
        setLinkedinData(null);

        if (option.value === "csv") {
            setIsUseFaceLeadPermission(false);
            setCsvPermission(true);
            setIsflOptionsPermission(false);
            setSourceApiPermission(false);
            setTiktokPermission(false);
            setGooglePermission(false);
            setShouldRenderLinkedin(false);
        } else if (option.value === "fl") {
            setSourceApiPermission(false);
            setIsUseFaceLeadPermission(true);
            setIsflOptionsPermission(true);
            setCsvPermission(false);
            getConnectedSources("fl");
            setConnectedSourceInput(true);
            setTiktokPermission(false);
            setGooglePermission(false);
            setShouldRenderLinkedin(false);
        } else if (option.value === "sapi") {
            setIsUseFaceLeadPermission(false);
            setCsvPermission(false);
            setIsflOptionsPermission(false);
            setSourceApiPermission(true);
            setTiktokPermission(false);
            getSourceApis();
            setGooglePermission(false);
            setShouldRenderLinkedin(false);
        } else if (option.value === "tiktok") {
            setIsUseFaceLeadPermission(false);
            setCsvPermission(false);
            setIsflOptionsPermission(false);
            setSourceApiPermission(false);
            setTiktokPermission(true);
            getConnectedSources("tiktok");
            setGooglePermission(false);
            setShouldRenderLinkedin(false);
        } else if (option.value === "gglw") {
            setIsUseFaceLeadPermission(false);
            setCsvPermission(false);
            setIsflOptionsPermission(false);
            setSourceApiPermission(false);
            setTiktokPermission(false);
            setGooglePermission(true);
            dispatch(getGoogleConnectedSources());
            setShouldRenderLinkedin(false);
        } else if (option.value === "lnkdn") {
            getConnectedSources("lnkdn");

            setSourceApiPermission(false);
            setIsUseFaceLeadPermission(false);
            setIsflOptionsPermission(false);
            setCsvPermission(false);
            setConnectedSourceInput(false);
            setTiktokPermission(false);
            setGooglePermission(false);
            setShouldRenderLinkedin(true);
        }
    };
    const getSourceApis = async () => {
        setLoadingForSourceApi(true);
        let data = {
            business_id: businessIdState,
        };
        let response = await getSorceApisAsync(data);
        if (response.status) {
            setLoadingForSourceApi(false);
            setSourceApiList(response?.data ?? "");
        } else {
            setLoadingForSourceApi(false);
        }
    };

    const [isLoadingConnectedSources, setIsLoadingConnectedSources] =
        useState(false);
    const getConnectedSources = async (code) => {
        setIsLoadingConnectedSources(true);
        let data = {
            source_type_code: code,
            all: true,
        };
        let response = await getConnectedSourceAsync(data);
        if (response.status) {
            setSourceConnectedList(response?.data ?? "");
        }
        setIsLoadingConnectedSources(false);
    };

    useEffect(() => {
        if (lastAddedService !== "") {
            setSelectedWebServiceId(lastAddedService?.destination_id ?? "");
        } else {
            setSelectedWebServiceId("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (lastAddedSourceApi !== "") {
            setSelectedSourceApiId(lastAddedSourceApi?.id ?? "");
        } else {
            setSelectedSourceApiId("");
        }
    }, [sourceApiList]);

    useEffect(() => {
        if (lastAddedSourceApi !== "") {
            setSelectedConnectedSourceApiId(lastAddedSourceApi?.id ?? "");
            setConnectionSourceName(lastAddedSourceApi?.name ?? "");
        } else {
            setSelectedConnectedSourceApiId("");
            setConnectionSourceName("");
        }
    }, [googleConnectedSources]);

    const connectSourceApiChange = (value, options) => {
        if (value === null) {
            return;
        }
        setSelectedSourceApiId(options.id);
    };

    const handleGoogleSourceChange = (value, options) => {
        if (value === null) {
            setSelectedConnectedSourceApiId(null);
            setConnectionSourceName(null);

            return;
        }
        setSelectedConnectedSourceApiId(options.id);
        setConnectionSourceName(options.name);
    };

    const [fbSourceFormStatus, setFbSourceFormStatus] = useState(false);
    const [fbReadySourceSelectStatus, setFbReadySourceSelectStatus] =
        useState(false);

    const connectedSourceChange = (value, options) => {
        setFbReadySourceSelectStatus(true);
        if (value === null) {
            return;
        }
        const sourcePages = normalizeFacebookPages(options.sourcePages ?? []);
        if (tiktokPermission) {
            setAppliedFBpermissionOpenSheet(true);
            setSourceSettingsPermission("success");
            setConnectionSourceName(options.name);
            setConnectFaceLeadsListChanged(
                sourcePages.map((item) => ({
                    value: item.id,
                    label: item.page_name,
                })),
            );
            setSelectedPages(
                sourcePages
                    .filter((x) => x.is_selected === true)
                    .map((item) => item?.id),
            );
            setConnectFaceLeadsList(sourcePages);
            setSelectedConnectedSource(options.name);
            setSelectedConnectedSourceApiId(options.id);
            setSelectedConnectedSourceApiPages(
                sourcePages.map((item) => item.id),
            );
        } else if (shouldRenderLinkedin) {
            setSelectedConnectedSourceApiId(options.id);
            setSelectedLinkedinSource(options);
            setShouldLoadLinkedinForms(false);
        } else {
            setAppliedFBpermissionOpenSheet(true);
            setSourceSettingsPermission("success");
            setConnectionSourceName(options.name);
            setConnectFaceLeadsListChanged(
                sourcePages.map((item) => ({
                    value: item.id,
                    label: item.page_name,
                })),
            );
            setChangedSelectedPagesForms(
                sourcePages
                    .filter((x) => x.is_selected === true)
                    .flatMap((item) =>
                        item.page_forms.map((item) => ({
                            value: item.id,
                            label: item.name,
                            parentId: item.parent_id,
                        })),
                    ),
            );
            setSelectedPages(
                sourcePages
                    .filter((x) => x.is_selected === true)
                    .map((item) => item?.id),
            );
            setConnectFaceLeadsList(sourcePages);
            setSelectedPageFormsValue(
                sourcePages
                    .filter((x) => x.is_selected === true)
                    ?.flatMap((item) =>
                        item.page_forms
                            ?.filter((x) => x.is_selected === true)
                            .map((item) => item?.id),
                    ),
            );
            setSelectedConnectedSourceApiId(options.id);
        }
    };

    const resetConnectedSourceSelection = () => {
        setFbReadySourceSelectStatus(false);
        setSelectedConnectedSourceApiId("");
        setSelectedConnectedSource(null);
        setSelectedConnectedSourceApiPages([]);
        setAppliedFBpermissionOpenSheet(false);
        setSourceSettingsPermission("idle");
        setConnectionSourceName(null);
        setSelectedPages([]);
        setSelectedPagesForms([]);
        setSelectedPageFormsValue([]);
        setConnectFaceLeadsListChanged([]);
        setChangedSelectedPagesForms([]);
        setConnectFaceLeadsList([]);
        setSelectedLinkedinSource(null);
        setLinkedinData(null);
        setShouldLoadLinkedinForms(false);
        setNextButtonDisabled(true);
    };

    // FACEBOOK
    const updatedData = async (data) => {
        setLeadFbLoaderStatus(true);
        if (data !== null) {
            setSelectedPages([]);
            setSelectedPageFormsValue([]);
            setIncludeAllForms(false);
            setShowArchivedForms(false);
            setFacebookAccessToken(data);
            sendFBInfosToServis(data, false);
        } else {
            setLeadFbLoaderStatus(false);
        }
    };

    const sendFBInfosToServis = async (
        data,
        includeArchived = false,
        isFormsRefresh = false,
    ) => {
        if (!isFormsRefresh) {
            setSourceSettingsPermission("pending");
        }
        let response;
        if (DEV_MODE && data === DEV_MOCK_FB_ACCESS_TOKEN) {
            await new Promise((resolve) => setTimeout(resolve, 600));
            response = {
                status: true,
                data: { data: buildDevMockFacebookPages() },
            };
        } else {
            let form = {
                access_token: data,
                business_id: businessIdState,
                source_type_code: sourceSelectionCode,
                ...(includeArchived && { include_archived: true }),
            };
            response = await sendFBInfosToServisAsync(form);
        }
        if (response.status) {
            const normalizedPages = normalizeFacebookPages(
                response?.data ?? [],
            );
            if (!isFormsRefresh) {
                setSourceSettingsPermission("success");
            }
            setFbSourceFormStatus(true);
            const resultLeadPagesChanged =
                normalizedPages.length > 0
                    ? normalizedPages.map((item) => ({
                          value: item.id,
                          label: item.page_name,
                      }))
                    : [];
            if (isFormsRefresh && selectedPages.length > 0) {
                const { selectedPageIds, selectedFormIds } =
                    remapFacebookPageAndFormSelections({
                        previousPages: connectFaceLeadsList,
                        nextPages: normalizedPages,
                        selectedPageIds: selectedPages,
                        selectedFormIds: selectedPageFormsValue,
                    });
                setSelectedPages(selectedPageIds);
                setSelectedPageFormsValue(selectedFormIds);
            }
            setConnectFaceLeadsList(normalizedPages);
            setConnectFaceLeadsListChanged(resultLeadPagesChanged);
            setAppliedFBpermissionOpenSheet(true);
            setLeadFbLoaderStatus(false);
            setIsFacebookFormsLoading(false);
            setNextButtonDisabled(false);
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message:
                    response.message &&
                    response.message +
                        `${
                            language?.lead?.please_reload_page ??
                            "Please reload page"
                        }`,
                icon: "error",
            });
            if (!isFormsRefresh) {
                setSourceSettingsPermission("error");
            }
            setLeadFbLoaderStatus(false);
            setIsFacebookFormsLoading(false);
        }
    };
    useEffect(() => {
        if (selectedPages.length > 0) {
            const result =
                connectFaceLeadsList.length > 0
                    ? connectFaceLeadsList.filter((el) =>
                          selectedPages.some((val) => el.id === val),
                      )
                    : [];
            if (tiktokPermission) {
                setSelectedPagesForms(result);
            } else {
                const pageForms = Array.isArray(result)
                    ? result.flatMap((item) => item.page_forms ?? [])
                    : [];
                setSelectedPagesForms(pageForms);
            }
        } else {
            setSelectedPagesForms([]);
        }
    }, [selectedPages, connectFaceLeadsList, tiktokPermission]);
    useEffect(() => {
        if (selectedPagesForms.length > 0) {
            let result = selectedPagesForms.map((item) => ({
                value: item.id,
                label: item.name,
                parentId: item.parentId || item.parent_id,
                status: item.status,
                created_time: item.created_time,
            }));
            setChangedSelectedPagesForms(result);
            if (selectedPageFormsValue && selectedPageFormsValue.length > 0) {
                let filteredselectedPageFormsValue =
                    selectedPageFormsValue.filter(
                        (element) =>
                            result &&
                            result.length > 0 &&
                            result.some((item) => item.value === element),
                    );
                setSelectedPageFormsValue(filteredselectedPageFormsValue);
            }
        } else {
            setChangedSelectedPagesForms([]);
            setSelectedPageFormsValue([]);
        }
    }, [selectedPagesForms]);
    const handleCloseSourceApiModal = () => {
        setIsSourceApiModalOpen(false);
    };

    const handleToggleReceiveNewForms = () => {
        setReceiveNewForms(!receiveNewForms);
    };
    const handleToggleShowArchivedForms = (event) => {
        const showArchived = event.target.checked;
        setShowArchivedForms(showArchived);
        if (facebookAccessToken) {
            setIsFacebookFormsLoading(true);
            sendFBInfosToServis(facebookAccessToken, showArchived, true);
        }
    };
    const handleToggleIncludeAllForms = (event) => {
        const shouldIncludeAllForms = event.target.checked;
        setIncludeAllForms(shouldIncludeAllForms);
        if (shouldIncludeAllForms) {
            setSelectedPageFormsValue(
                changedSelectedPagesForms.map((form) => form.value),
            );
        }
    };
    useEffect(() => {
        if (includeAllForms) {
            setSelectedPageFormsValue(
                changedSelectedPagesForms.map((form) => form.value),
            );
        }
    }, [changedSelectedPagesForms, includeAllForms]);
    const showError = (errorMessage) => {
        Swal.fire({
            title: language?.delete_swal_modal?.failed ?? "Failed",
            text: errorMessage,
            icon: "error",
            showClass: {
                popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
                popup: "animate__animated animate__fadeOutUp",
            },
            timer: 3000,
        });
    };

    useEffect(() => {
        if (
            sourceSelectionCode === "tiktok" &&
            Object.keys(tiktokStoreData).length > 0
        ) {
            setNextButtonDisabled(false);
        }
    }, [tiktokStoreData]);

    const toNext = () => {
        if (
            (connectionSourceName === "" || connectionSourceName === null) &&
            sourceSelectionCode !== "sapi" &&
            sourceSelectionCode !== "lnkdn"
        ) {
            showError("Please enter source name!");
        } else if (sourceSelectionCode === "") {
            // showError("Please select a Source!");
            setIsSourceSelected(true);
        } else if (
            sourceSelectionCode !== "fl" &&
            sourceSelectionCode !== "tiktok" &&
            sourceSelectionCode !== "gglw" &&
            sourceSelectionCode !== "lnkdn" &&
            selectedSourceApiId === "" &&
            selectedPages.length === 0 &&
            selectedPageFormsValue.length === 0
        ) {
            showError("Please select your source options!");
        } else if (
            sourceSelectionCode !== "tiktok" &&
            sourceSelectionCode !== "lnkdn" &&
            selectedSourceApiId === "" &&
            selectedPages.length > 0 &&
            changedSelectedPagesForms.length === 0 &&
            !(sourceSelectionCode === "fl" && includeAllForms)
        ) {
            showError("Please select a page with the form!");
        } else if (
            sourceSelectionCode !== "tiktok" &&
            sourceSelectionCode !== "lnkdn" &&
            selectedSourceApiId === "" &&
            selectedPages.length > 0 &&
            selectedPageFormsValue.length === 0 &&
            !(sourceSelectionCode === "fl" && includeAllForms)
        ) {
            showError("Please select a form!");
        } else if (
            sourceSelectionCode === "fl" &&
            includeAllForms &&
            selectedPages.length === 0
        ) {
            showError("Please select at least one page!");
        } else if (
            selectedConnectedSource === "" &&
            sourceSelectionCode === "tiktok" &&
            Object.keys(tiktokStoreData).length === 0
        ) {
            showError("Please select your source pages!");
        } else if (
            selectedConnectedSource === "" &&
            sourceSelectionCode === "tiktok" &&
            Object.keys(tiktokStoreData?.selected_pages).length === 0
        ) {
            showError("Please select your source pages!");
        } else {
            let willSendData = {};
            if (
                selectedSourceApiId === "" &&
                sourceSelectionCode !== "tiktok"
            ) {
                if (
                    selectedConnectedSourceApiPages !== undefined &&
                    selectedConnectedSourceApiPages.length > 0
                ) {
                    willSendData = {
                        business_id: businessIdState,
                        source_type_code: sourceSelectionCode,
                        destination_id: allZohoFields.destination_id
                            ? allZohoFields.destination_id
                            : selectedWebServiceId,
                        destination_type_code: destinationSelectionCode,
                        selected_source_id: selectedConnectedSourceApiId,
                        receive_new_forms: receiveNewForms ? 1 : 0,
                        selected_pages: [...selectedConnectedSourceApiPages]
                            .map((page) => {
                                const selectedForms = (page.page_forms ?? [])
                                    .filter(
                                        (form) =>
                                            form.is_selected === true ||
                                            form.is_selected === 1,
                                    )
                                    .map((form) => form.id);
                                return selectedForms.length > 0
                                    ? {
                                          page_id: page.id,
                                          selected_forms: selectedForms,
                                          check_new_form: receiveNewForms
                                              ? 1
                                              : 0,
                                      }
                                    : null;
                            })
                            .filter(Boolean),
                    };
                } else if (sourceSelectionCode === "gglw") {
                    willSendData = {
                        business_id: businessIdState,
                        source_type_code: sourceSelectionCode,
                        destination_id: allZohoFields.destination_id
                            ? allZohoFields.destination_id
                            : selectedWebServiceId,
                        destination_type_code: destinationSelectionCode,
                        source_id: selectedConnectedSourceApiId,
                        receive_new_forms: receiveNewForms ? 1 : 0,
                    };
                } else if (sourceSelectionCode === "lnkdn") {
                    willSendData = {
                        business_id: businessIdState,
                        source_type_code: sourceSelectionCode,
                        destination_id: allZohoFields.destination_id
                            ? allZohoFields.destination_id
                            : selectedWebServiceId,
                        selected_pages: [
                            {
                                page_id: linkedinData?.selectedAdAccountID,
                                selected_forms:
                                    linkedinData?.selectedForms?.map(
                                        (form) => form?.id || form?.form_id,
                                    ),
                            },
                        ],
                        destination_type_code: destinationSelectionCode,
                        source_id: linkedinData?.sourceAccountID,
                        receive_new_forms: receiveNewForms ? 1 : 0,
                    };
                } else {
                    const isNewFacebookSource =
                        sourceSelectionCode === "fl" &&
                        !selectedConnectedSourceApiId;
                    const shouldIncludeAllForms =
                        isNewFacebookSource && includeAllForms;
                    const shouldReceiveNewForms =
                        shouldIncludeAllForms || receiveNewForms;
                    willSendData = {
                        business_id: businessIdState,
                        source_type_code: sourceSelectionCode,
                        destination_id: allZohoFields.destination_id
                            ? allZohoFields.destination_id
                            : selectedWebServiceId,
                        destination_type_code: destinationSelectionCode,
                        selected_pages: buildFacebookSelectedPages({
                            pages: connectFaceLeadsList,
                            selectedPageIds: selectedPages,
                            selectedFormIds: selectedPageFormsValue,
                            includeAllForms: shouldIncludeAllForms,
                            checkNewForm: shouldReceiveNewForms,
                        }),
                        receive_new_forms: shouldReceiveNewForms ? 1 : 0,
                        ...(shouldIncludeAllForms && {
                            include_all_forms: true,
                        }),
                        source_name: connectionSourceName,
                    };
                }
            } else if (
                sourceSelectionCode === "fl" &&
                selectedConnectedSourceApiPages !== undefined
            ) {
                willSendData = {
                    business_id: businessIdState,
                    source_type_code: sourceSelectionCode,
                    destination_id: allZohoFields.destination_id
                        ? allZohoFields.destination_id
                        : selectedWebServiceId,
                    destination_type_code: destinationSelectionCode,
                    selected_source_id: selectedConnectedSourceApiId,
                    receive_new_forms: receiveNewForms ? 1 : 0,
                    selected_pages: [...selectedConnectedSourceApiPages]
                        .map((item) => {
                            const selectedForms = (item.page_forms ?? [])
                                .filter(
                                    (form) =>
                                        form.parent_id === item.id &&
                                        (form.is_selected === true ||
                                            form.is_selected === 1),
                                )
                                .map((form) => form.id);

                            return selectedForms.length > 0
                                ? {
                                      page_id: item.id,
                                      selected_forms: selectedForms,
                                      check_new_form: receiveNewForms ? 1 : 0,
                                  }
                                : null;
                        })
                        .filter(Boolean),
                };
            } else {
                willSendData = {
                    business_id: businessIdState,
                    source_type_code: sourceSelectionCode,
                    destination_id: allZohoFields.destination_id
                        ? allZohoFields.destination_id
                        : selectedWebServiceId,
                    destination_type_code: destinationSelectionCode,
                    source_id: selectedSourceApiId,
                    receive_new_forms: receiveNewForms ? 1 : 0,
                };
            }

            setIsSourceSelected(false);
            postStep1Datas(willSendData);
            dispatch(stepOneData(willSendData));
        }
    };

    const postStep1Datas = async (Step1Data) => {
        setIsLoading(true);
        if (sourceSelectionCode === "tiktok") {
            if (!!selectedConnectedSource) {
                let data = {
                    business_id: businessIdState,
                    source_type_code: "tiktok",
                    destination_id: allZohoFields.destination_id
                        ? allZohoFields.destination_id
                        : selectedWebServiceId,
                    destination_type_code: destinationSelectionCode,
                    selected_source_id: selectedConnectedSourceApiId,
                    source_id: selectedConnectedSourceApiId,
                    receive_new_forms: receiveNewForms ? 1 : 0,
                    selected_pages: [...selectedConnectedSourceApiPages].map(
                        (pageId) => ({
                            page_id: pageId,
                            selected_forms: [pageId],
                            check_new_form: receiveNewForms ? 1 : 0,
                        }),
                    ),
                };
                if (props?.setSelectedSourceId !== undefined) {
                    props?.setSelectedSourceId(selectedConnectedSourceApiId);
                }
                if (props?.setStep1Data !== undefined) {
                    props?.setStep1Data(data);
                    setIsLoading(false);
                    props.nextStep();
                }
            } else {
                let tiktokCreate = await tiktokStore({
                    ...tiktokStoreData,
                    check_new_forms: tiktokReceiveNewForms ? 1 : 0,
                });
                if (tiktokCreate.status) {
                    if (props?.setSelectedSourceId !== undefined) {
                        props?.setSelectedSourceId(
                            tiktokCreate?.data?.source_id,
                        );
                    }
                    let data = {
                        source_type_code: "tiktok",
                        source_id: tiktokCreate?.data?.source_id,
                        destination_id: allZohoFields.destination_id
                            ? allZohoFields.destination_id
                            : selectedWebServiceId,
                        destination_type_code: destinationSelectionCode,
                        receive_new_forms: tiktokReceiveNewForms ? 1 : 0,
                    };
                    if (props?.setStep1Data !== undefined) {
                        props?.setStep1Data(data);
                        setIsLoading(false);
                        props.nextStep();
                    }
                } else {
                    setIsLoading(false);
                    SwalAlertComp({
                        title: language?.delete_swal_modal?.failed ?? "Failed",
                        message: tiktokCreate.message && tiktokCreate.message,
                        icon: "error",
                    });
                }
            }
        } else {
            if (props?.setStep1Data !== undefined) {
                props?.setStep1Data(Step1Data);
                setIsLoading(false);
                props.nextStep();
            }
        }
    };
    const GetOptionValueView = (options, key) => {
        if (
            typeof key === "string" &&
            key !== "" &&
            options &&
            options.length > 0
        ) {
            let label = options?.find((x) => x?.value === key).label || "";
            return {
                label: label,
                value: key,
            };
        } else {
            return {
                label: "",
                value: "none",
            };
        }
    };

    const getSelectOptions = (options) => {
        if (options && options.length > 0) {
            return options.map((x) => ({ label: x.name, value: x.code }));
        } else {
            return [];
        }
    };

    const handleFbRefresh = () => {
        setLeadFbLoaderStatus(true);
        setSelectedPages([]);
        setSelectedPageFormsValue([]);
        if (DEV_MODE) {
            setTimeout(() => {
                updatedData(DEV_MOCK_FB_ACCESS_TOKEN);
            }, 800);
            return;
        }
        window.FB.login(
            function (responseFB) {
                if (responseFB.authResponse) {
                    let login_access_token =
                        responseFB.authResponse.accessToken;
                    updatedData(login_access_token);
                } else {
                    SwalAlertComp({
                        title: language?.delete_swal_modal?.failed ?? "Failed",
                        message:
                            "Error. No Pixel found! User cancelled login or did not fully authorize.",
                        icon: "error",
                    });
                    setLeadFbLoaderStatus(false);
                }
            },
            {
                scope: "pages_manage_ads,pages_read_engagement,pages_show_list,pages_manage_metadata,leads_retrieval,pages_show_list,pages_manage_metadata",
                auth_type: "rerequest",
            },
        );
    };

    const isPrimaryDisabled =
        (sourceSelectionCode === "fl" &&
            !includeAllForms &&
            !changedSelectedPagesForms.length) ||
        (sourceSelectionCode === "tiktok" &&
            !selectedTiktokForms.length &&
            !connectFaceLeadsListChanged.length) ||
        (sourceSelectionCode === "sapi" && !selectedSourceApiId) ||
        (sourceSelectionCode === "lnkdn" &&
            (!linkedinData?.selectedAdAccountID ||
                !linkedinData?.selectedForms?.length)) ||
        !sourceSelectionCode;

    return (
        <>
            <WizardStepLayout
                primaryTestId="lead-source-next"
                maxWidth="100%"
                descriptionTitle={
                    language?.lead_wizard?.what_is_source ?? "What is Source?"
                }
                description={
                    language?.lead_wizard?.what_is_source_desc ??
                    "The source is the origin of your data, typically where the leads are initially collected. It defines the point of entry for information into the system."
                }
                onPrimary={toNext}
                primaryLabel={language?.buttons?.next ?? "Next"}
                primaryDisabled={isPrimaryDisabled}
                isLoading={isLoading}
            >
                <Box
                    className={`position-relative z-1 ${
                        isLoading ? "loader-blur" : ""
                    }`}
                >
                    <Autocomplete
                        ref={sourceSelectRef}
                        label={language?.lead?.select_source ?? "Select Source"}
                        value={GetOptionValueView(
                            getSelectOptions(allLeadSource),
                            sourceSelectionCode,
                        )}
                        className="select-image-list tour-source-select mb-3"
                        options={
                            allLeadSource && getSelectOptions(allLeadSource)
                        }
                        disableClearable
                        getOptionLabel={(option) => option.label || ""}
                        onChange={(event, selectedOpt) => {
                            sourceOnChange(
                                selectedOpt?.value,
                                getSelectOptions(allLeadSource).find(
                                    (x) => x?.value === selectedOpt?.value,
                                ),
                            );
                            setTiktokAppStatus(false);
                        }}
                        renderInput={(params) => (
                            <div>
                                <TextField
                                    {...params}
                                    data-cy="lead-source-type"
                                    label={
                                        language?.source_modal?.select_source ??
                                        "Select Source"
                                    }
                                    error={isSourceSelected}
                                    InputProps={{
                                        ...params.InputProps,
                                        startAdornment: (
                                            <img
                                                style={{
                                                    width: "25px",
                                                    margin: "5px",
                                                    marginTop: "10px",
                                                }}
                                                src={getSourceIcon(
                                                    params?.inputProps?.value,
                                                )}
                                            />
                                        ),
                                    }}
                                />
                            </div>
                        )}
                        renderOption={(props, option) => (
                            <Box
                                component="li"
                                sx={{
                                    "& > img": { mr: 2, flexShrink: 0 },
                                }}
                                {...props}
                            >
                                <img
                                    width="25"
                                    src={getSourceIcon(option?.value)}
                                />
                                {option.label}
                            </Box>
                        )}
                    />
                    {isLoadingConnectedSources && (
                        <Box className="d-flex justify-content-center align-items-center mt-5 mb-5">
                            <CircularProgress size={17} />
                        </Box>
                    )}
                    {isflOptionsPermission && (
                        <FacebookLeadSourceSection
                            leadFbLoaderStatus={leadFbLoaderStatus}
                            isUseFaceLeadPermission={isUseFaceLeadPermission}
                            connectedSourceInput={connectedSourceInput}
                            sourceConnectedList={sourceConnectedList}
                            fbSourceFormStatus={fbSourceFormStatus}
                            fbReadySourceSelectStatus={
                                fbReadySourceSelectStatus
                            }
                            connectedSourceChange={connectedSourceChange}
                            resetConnectedSourceSelection={
                                resetConnectedSourceSelection
                            }
                            selectedConnectedSourceApiId={
                                selectedConnectedSourceApiId
                            }
                            setNextButtonDisabled={setNextButtonDisabled}
                            appliedFBpermissionOpenSheet={
                                appliedFBpermissionOpenSheet
                            }
                            sourceSettingsPermission={sourceSettingsPermission}
                            handleConnectionSourceName={
                                handleConnectionSourceName
                            }
                            connectionSourceName={connectionSourceName}
                            selectedPages={selectedPages}
                            connectFaceLeadsListChanged={
                                connectFaceLeadsListChanged
                            }
                            handleSelectedPages={handleSelectedPages}
                            handleFbRefresh={handleFbRefresh}
                            changedSelectedPagesForms={
                                changedSelectedPagesForms
                            }
                            selectedPageFormsValue={selectedPageFormsValue}
                            handleSelectedPagesForms={handleSelectedPagesForms}
                            receiveNewForms={receiveNewForms}
                            onToggleReceiveNewForms={
                                handleToggleReceiveNewForms
                            }
                            showArchivedForms={showArchivedForms}
                            onToggleShowArchivedForms={
                                handleToggleShowArchivedForms
                            }
                            canReloadFacebookForms={!!facebookAccessToken}
                            isFacebookFormsLoading={isFacebookFormsLoading}
                            includeAllForms={includeAllForms}
                            onToggleIncludeAllForms={
                                handleToggleIncludeAllForms
                            }
                            updatedData={updatedData}
                        />
                    )}
                    {csvPermission && (
                        <CsvLeadSourceSection
                            onFileSelected={() => setNextButtonDisabled(false)}
                        />
                    )}
                    {sourceApiPermission && (
                        <SourceApiLeadSourceSection
                            isLoading={loadingForSourceApi}
                            sourceApiList={sourceApiList}
                            sourceLabel={sourceSelections}
                            selectedSourceApiId={selectedSourceApiId}
                            connectSourceApiChange={connectSourceApiChange}
                            setNextButtonDisabled={setNextButtonDisabled}
                            onCreateNew={() => setIsSourceApiModalOpen(true)}
                        />
                    )}
                    {googlePermission && (
                        <GoogleLeadSourceSection
                            selectedConnectedSourceApiId={
                                selectedConnectedSourceApiId
                            }
                            handleGoogleSourceChange={handleGoogleSourceChange}
                            setNextButtonDisabled={setNextButtonDisabled}
                        />
                    )}
                    {tiktokPermission && (
                        <TiktokLeadSourceSection
                            sourceConnectedList={sourceConnectedList}
                            fbReadySourceSelectStatus={
                                fbReadySourceSelectStatus
                            }
                            tiktokAppStatus={tiktokAppStatus}
                            sourceSettingsPermission={sourceSettingsPermission}
                            selectedConnectedSource={selectedConnectedSource}
                            connectedSourceChange={connectedSourceChange}
                            resetConnectedSourceSelection={
                                resetConnectedSourceSelection
                            }
                            setNextButtonDisabled={setNextButtonDisabled}
                            connectionSourceName={connectionSourceName}
                            handleConnectionSourceName={
                                handleConnectionSourceName
                            }
                            selectedPages={selectedPages}
                            connectFaceLeadsListChanged={
                                connectFaceLeadsListChanged
                            }
                            handleSelectedPages={handleSelectedPages}
                            receiveNewForms={receiveNewForms}
                            onToggleReceiveNewForms={
                                handleToggleReceiveNewForms
                            }
                            setTiktokAppStatus={setTiktokAppStatus}
                            setTiktokStoreData={setTiktokStoreData}
                            tiktokReceiveNewForms={tiktokReceiveNewForms}
                            setTiktokReceiveNewForms={setTiktokReceiveNewForms}
                            setConnectionSourceName={setConnectionSourceName}
                            setTiktokSelectedForms={setTiktokSelectedForms}
                        />
                    )}

                    {shouldRenderLinkedin && (
                        <LinkedinLeadSourceSection
                            sourceConnectedList={sourceConnectedList}
                            selectedConnectedSourceApiId={
                                selectedConnectedSourceApiId
                            }
                            isLoadingConnectedSources={
                                isLoadingConnectedSources
                            }
                            connectedSourceChange={connectedSourceChange}
                            resetConnectedSourceSelection={
                                resetConnectedSourceSelection
                            }
                            setNextButtonDisabled={setNextButtonDisabled}
                            selectedLinkedinSource={selectedLinkedinSource}
                            setLinkedinData={setLinkedinData}
                            shouldLoadLinkedinForms={shouldLoadLinkedinForms}
                            setShouldLoadLinkedinForms={
                                setShouldLoadLinkedinForms
                            }
                        />
                    )}
                </Box>
            </WizardStepLayout>
            {isSourceApiModalOpen && (
                <AddEditSourceApi
                    onSuccess={runDispatcherAfterCreate}
                    handleCloseSourceApiModal={handleCloseSourceApiModal}
                />
            )}
        </>
    );
};

export default LeadsStep1;
